<template>
  <z-dialogo ref="dialogo" :titulo="titulo" :dividers="true" largura="500px" persistent>
    
    <template #texto>
      <v-row dense>
        <v-col cols="12" sm="12">
          <v-checkbox
            color="primary"
            class="mt-0"
            v-model="filtro.periodo"
            label="Período"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <z-date-picker-menu label="Data Incial" v-model="filtro.data_inicial" :disabled="filtro.periodo==0"></z-date-picker-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <z-date-picker-menu label="Data Final" v-model="filtro.data_final" :disabled="filtro.periodo==0"></z-date-picker-menu>
        </v-col>

        <v-col cols="12" sm="12">
          <z-select :items="ordenacao" label="Ordenar por" placeholder=" " v-model="filtro.ordem"></z-select>
        </v-col>

        <v-col cols="12" sm="12">
          <z-select
            v-model="filtro.produto_grupo_id"
            label="Grupo"
            clearable
            :items="$store.getters['listas/grupos']"
          ></z-select>
        </v-col>

        <v-col cols="12" sm="12" v-if="config.FILTRO_HERDEIRO_NO_MOVIMENTO">
          <z-select
            v-model="filtro.herdeiro"
            label="Herdeiro"
            clearable
            :items="['Herdeiro 1', 'Herdeiro 2', 'Herdeiro 3', 'Herdeiro 4', 'Herdeiro 5', 'Herdeiro 6', 'Herdeiro 7', 'Herdeiro 8', 'Herdeiro 9', 'Herdeiro 10']"
          ></z-select>
        </v-col>

        <v-col cols="12" sm="6">
          <v-checkbox
            color="primary"
            class="mt-0"
            v-model="filtro.incluir_valor_venda"
            label="Incluir Valor de Venda"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <v-checkbox
            color="primary"
            class="mt-0"
            v-model="filtro.incluir_valor_custo"
            label="Incluir Valor de Custo"
            :true-value="1"
            :false-value="0"
            single-line
            hide-details
          ></v-checkbox>
        </v-col>

      </v-row>
    </template>

    <template #actions_right>
      <v-btn text @click="$refs.dialogo.fechar()">
        Cancelar
      </v-btn>
      <v-btn depressed color="primary" @click="imprimir">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
    </template>

  </z-dialogo>
</template>

<script>
import qs from "qs";
import config from "@/app/config";
import { parseParams } from '@/app/helpers/utils';

export default {
  name: 'EntradasDeProdutos',

  props: {
    titulo: {
      type: String,
      default: 'Entradas de Produtos'
    },
    relatorio: {
      type: String,
      default: '' 
    },
  },
  inject: ['$imprimir'],

  data () {
    return {
      aberto: 0,
      filtro: {
        periodo: 0,
        data_inicial: this.$moment().format('YYYY-MM-DD'),
        data_final: this.$moment().format('YYYY-MM-DD'),
        ordem: 'referencia',
        produto_grupo_id: null,
        incluir_valor_venda: 0,
        incluir_valor_custo: 0
      },
      ordenacao: [
        {text: 'Referência', value: 'referencia'},
        {text: 'Descrição', value: 'descricao'}
      ]
    }
  },

  computed: {
    config() {
      return this.$store.state.configuracoes;
    },
  },

  mounted() {
    this.$store.dispatch("listas/grupos");
  },

  methods: {
    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    imprimir() {
      this.filtro.r = this.relatorio;

      const filtro = {
        ...this.filtro,
        data_inicial: this.filtro.periodo ? this.filtro.data_inicial : null,
        data_final: this.filtro.periodo ? this.filtro.data_final : null,
      }

      this.$imprimir("/relatorios/entradadeprodutos?" + new URLSearchParams(parseParams(filtro)).toString(), "relatorio_de_entradas.pdf");

      // if (config.IS_PRODUCTION) {
      //   this.abrirJanela(window.location.origin + '/relatorios/entradadeprodutos?'+ qs.stringify(this.filtro));
      // } else {
      //   this.abrirJanela('http://localhost:8001/relatorios/entradadeprodutos?'+ qs.stringify(this.filtro));
      // }
    },
  }
}
</script>

<style scoped>

</style>